// Mensajes validacion componente Solicitud Credito

export const solicitudErrorCuentaExterna = "Debe seleccionar un numero de cuenta externa para continuar con el proceso.";
export const solicitudErrorTipoCuenta = "";
export const stepsSolicitudCredito = ["Informacion Socio", "Garantes", "Tabla amortizacion", "Flujo Efectivo", "5c"]
export const stepsPersonas = ["Lista", "Datos Básicos", "Direccion", "Actividad Economica"]
export const stepsSocio = ["Lista", "Nuevo Socio", "Tipos de Cuenta"]
export const stepsSocioNuevo = ["Lista Socio", "Nuevo Socio", "Dirección", "Actividad Económica", "Contacto"]
export const stepsFlujo = ["Patrimonio", "Flujo Efectivo"]
export const listaPlazosUtil = [

        {
            codigo: 1,
            plazo: 3 // En meses
        },
        {
            codigo: 2,
            plazo: 6 // En meses
        },
        {
            codigo: 3,
            plazo: 9 // En meses
        },
        {
            codigo: 4,
            plazo: 12 // En meses
        },
        {
            codigo: 5,
            plazo: 18 // En meses
        },
        {
            codigo: 6,
            plazo: 24 // En meses
        },
        {
            codigo: 7,
            plazo: 36 // En meses
        }
    ]
    // DATOS FIJOS PARA SISTEMA
export const codigoEmpresa = 1;
export const codigoAgencia = 1;
export const codigoEstadoOperacion = 1;
// DATOS TIPO DE MENSAJES PROCESOS
export const procesoOK = 'success';
export const procesoWarning = 'warning';
export const procesoError = 'error';
export const procesoInfo = 'info';
// DATOS TIPO CUOTA
export const listaTipoCuota = [{
        codigo: 1,
        nomenclatura: 'F',
        descripcion: 'Cuota fija'
    },
    {
        codigo: 2,
        nomenclatura: 'V',
        descripcion: 'Cuota variable'
    }
]